document.addEventListener("DOMContentLoaded", function () {

  // Wedding date picker
  if (document.querySelector("#wedding-date")) {
    flatpickr("#wedding-date", {
      altInput: true,
      altFormat: "d F Y",
      dateFormat: "Y-m-d",
      minDate: "today",
      allowInput: true,
      disableMobile: true,
    });
  }


  const form = document.getElementById("bridal-appointment-form");


  if (!form) return;



  form.addEventListener("submit", function (e) {

    e.preventDefault();



    const product =
      window.appointmentProducts[selectedAppointment];



    const properties = {

      Name:
      document.getElementById("name").value,

      Email:
      document.getElementById("email").value,

      Phone:
      document.getElementById("phone").value,

      "Wedding Date":
      document.getElementById("wedding-date").value,

      "Wedding Location":
      document.getElementById("venue").value,

      "Design Vision":
      document.getElementById("styles").value,

      "Second Look / Accessories":
      document.getElementById("accessories").value,

      "How did you hear about us?":
      document.getElementById("heard-about").value,


      "Consultation Type":
      selectedAppointment === "atelier"
        ? "Atelier"
        : "Virtual"

    };



    let calendlyUrl;


if (selectedAppointment === "atelier") {

  calendlyUrl =
    "https://calendly.com/marcela-giocanti/60min";

} else {

  calendlyUrl =
    "https://calendly.com/marcela-giocanti/45min";

}



    // Store details until Calendly confirms booking
    window.pendingAppointment = {
      product,
      properties
    };



    // Open Calendly popup
if (window.Calendly) {

  const name = document.getElementById("name").value;
  const email = document.getElementById("email").value;

const calendlyParams =
  "?name=" + encodeURIComponent(name) +
  "&email=" + encodeURIComponent(email) +
  "&hide_event_type_details=1" +
  "&primary_color=000000" +
  "&hide_gdpr_banner=1";
  


Calendly.initPopupWidget({
  url: calendlyUrl + calendlyParams
});

    } else {

      console.error("Calendly has not loaded");

      alert(
        "Sorry, the appointment scheduler is still loading. Please try again."
      );

    }


  });



});





// Listen for successful Calendly booking

window.addEventListener(
  "message",
  async function (e) {


    if (
      e.data.event === "calendly.event_scheduled"
    ) {


      const appointment =
        window.pendingAppointment;



      if (!appointment) {
        console.error(
          "No appointment data found"
        );
        return;
      }



      try {


        await fetch("/cart/add.js", {

          method: "POST",

          headers: {
            "Content-Type": "application/json"
          },

          body: JSON.stringify({

            id:
            appointment.product.variant,

            quantity: 1,

            properties:
            appointment.properties

          })

        });



        window.location.href = "/cart";


      } catch (err) {


        console.error(err);


        alert(
          "Sorry, something went wrong. Please try again."
        );


      }


    }


  }
);